import React from 'react';
import { Container } from '../ui/Container';
import { LinkedinIcon, SendIcon } from 'lucide-react';
export const FooterSection: React.FC = () => {
  return <footer className="w-full bg-gradient-to-b from-dark-800 to-dark-900 py-20 relative" data-id="element-592">
      <div className="absolute inset-0 bg-[url('https://transparenttextures.com/patterns/carbon-fibre.png')] opacity-5" data-id="element-593" />
      <Container className="relative" data-id="element-594">
        <div className="flex flex-col items-center text-center" data-id="element-595">
          <h3 className="text-2xl font-bold mb-6 text-white" data-id="element-596">Contact</h3>
          <p className="text-gray-300 mb-2" data-id="element-597">dj@getdealflow.ai</p>
          <p className="text-gray-300 mb-6" data-id="element-598">(775) 842-4841</p>
          <div className="flex space-x-4 mb-8" data-id="element-599">
            <span className="text-gray-300 hover:text-[#00c853] transition-colors cursor-pointer" data-id="element-600">
              <LinkedinIcon className="w-6 h-6" data-id="element-601" />
            </span>
            <span className="text-gray-300 hover:text-[#00c853] transition-colors cursor-pointer" data-id="element-602">
              <SendIcon className="w-6 h-6" data-id="element-603" />
            </span>
          </div>
          <div className="border-t border-dark-600 pt-8 w-full" data-id="element-604">
            <p className="text-gray-400" data-id="element-605">
              © {new Date().getFullYear()} GetDealFlow.ai. All rights reserved.
            </p>
          </div>
        </div>
      </Container>
    </footer>;
};